export default "__VITE_ASSET__DDs06qwt__"